import { defaultTo } from "lodash";
import { petcoPewterBlue } from "@common/_assets/color-constants.js";

/**
 * Introduced for GetHospitalSchedule, a light weight vet listing model with no sub types on it.  This
 * is returned from GetHospitalSchedule on ProcessedHospitalScheduleModel
 */
export class VeterinarianListingModel {
    veterinarianId: number;
    title: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    username: string;
    fullName: string;
    schedulingColor: string | undefined;
    sourceSystemKey: string | undefined;
    titleFullName: string;
    employmentStatus: string;

    constructor(init?: Partial<VeterinarianListingModel>) {
        this.veterinarianId = defaultTo(init?.veterinarianId, 0);
        this.title = defaultTo(init?.title, undefined);
        this.firstName = defaultTo(init?.firstName, '');
        this.lastName = defaultTo(init?.lastName, '');
        this.email = defaultTo(init?.email, '');
        this.username = defaultTo(init?.username, '');
        this.fullName = defaultTo(init?.fullName, '');
        this.titleFullName = defaultTo(init?.titleFullName, '');
        this.schedulingColor = defaultTo(init?.schedulingColor, petcoPewterBlue);
        this.employmentStatus = defaultTo(init?.employmentStatus, '')
    }
}
